import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { type ImageSourcePropType, type ImageStyle, StyleSheet } from 'react-native';

import { ContentfulImage, type ContentfulImageTransformOptions, Image } from '@sg/garnish';

export const LoyaltyPostPurchaseHero = (props: LoyaltyPostPurchaseHeroProps) => {
  const { image, style } = props;

  const { formatMessage } = useIntl();

  const imageA11yLabel = formatMessage(messages.imageA11yLabel);

  if (image.url) {
    return (
      <ContentfulImage
        style={[styles.image, style]}
        contentFit="cover"
        aria-label={imageA11yLabel}
        baseUrl={image.url}
        options={CONTENTFUL_IMAGE_OPTIONS}
      />
    );
  }

  return (
    <Image
      style={[styles.image, style]}
      contentFit="cover"
      aria-label={imageA11yLabel}
      source={image.fallbackSource}
    />
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  imageA11yLabel: {
    defaultMessage: 'Post Purchase modal image',
    description: 'Loyalty Post Purchase | Modal Hero | a11y label',
  },
});

// ─── Constants ───────────────────────────────────────────────────────────────

const CONTENTFUL_IMAGE_OPTIONS: Partial<ContentfulImageTransformOptions> = {
  fm: 'webp',
  q: 70,
  w: 600,
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  image: {
    width: '100%',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type LoyaltyPostPurchaseHeroProps = {
  image: {
    fallbackSource?: ImageSourcePropType;
    url?: string;
    description: string;
  };
  style?: ImageStyle;
};
